import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 6F488FA3-B882-443D-8619-0124217E267C
 * name truck-trailer
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-trailer.svg
 * tags
 * - Transportation + Road 
 */
export const TruckTrailerIcon = createSvgIcon(<><path d="M22,15V17H10A3,3 0 0,1 7,20A3,3 0 0,1 4,17H2V6A2,2 0 0,1 4,4H17A2,2 0 0,1 19,6V15H22M7,16A1,1 0 0,0 6,17A1,1 0 0,0 7,18A1,1 0 0,0 8,17A1,1 0 0,0 7,16Z" /></>, 'TruckTrailerIcon');
export default TruckTrailerIcon